import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  CPP_MarketingAllComponentWrapper: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    padding: '20px 32px',
    height: 'fit-content',
    width: '100%',
    borderRadius: '0px 12px 12px 12px',
    backgroundColor: theme.palette.background.primary,
    boxSizing: 'border-box',
    [theme.breakpoints.down('md')]: {
      padding: '16px 20px',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '12px 16px',
      gap: '16px',
    },
  },
  aiGenerateButtonSection: {
    display: 'flex',
    justifyContent: 'flex-start',
    marginBottom: '16px',
  },
  aiGenerateButton: {
    backgroundColor: 'transparent',
    border: `1px solid ${theme.palette.border.secondary}`,
    borderRadius: '8px',
    padding: '8px 16px',
    color: theme.palette.text.secondary,
    fontSize: '14px',
    fontWeight: '500',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: theme.palette.background.gray_50,
      borderColor: theme.palette.button.primary_border,
    },
    '& span': {
      display: 'flex',
      alignItems: 'center',
      gap: '4px',
    },
  },
  CPP_itemWrapper: {
    width: '100%',
    height: '100%',
    maxHeight: '44px',
    display: 'flex',
    alignItems: 'flex-start',
    gap: '32px',
    margin: '16px 0',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      maxHeight: 'none',
      gap: '12px',
    },
  },
  CPP_fieldLabel: {
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '20px',
    color: theme.palette.text.secondary,
    height: '20px',
    width: '280px',
    minWidth: '120px',
    flexShrink: 0,
    [theme.breakpoints.down('md')]: {
      width: '200px',
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  CPP_fieldWrapper: {
    width: '100%',
    height: '100%',
    maxWidth: '512px',
    maxHeight: '44px',
    display: 'flex',
    alignItems: 'center',
  },
  propertyLabelSection: {
    display: 'flex',
    alignItems: 'center',
    minHeight: '92px',
    width: '100%',
    backgroundColor: theme.palette.background.gray_50,
    border: '1px solid ' + theme.palette.border.secondary,
    borderRadius: '12px',
    padding: '24px 32px',
    boxSizing: 'border-box',
    [theme.breakpoints.down('md')]: {
      padding: '20px 24px',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '16px 20px',
      minHeight: 'auto',
    },
  },
  priceAndSizeSection: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '92px',
    height: 'fit-content',
    width: '100%',
    backgroundColor: theme.palette.background.gray_50,
    border: '1px solid ' + theme.palette.border.secondary,
    borderRadius: '12px',
    padding: '24px 32px',
    gap: '20px',
    boxSizing: 'border-box',
    [theme.breakpoints.down('md')]: {
      padding: '20px 24px',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '16px 20px',
      gap: '16px',
    },
  },
  sizeField: {
    display: 'flex',
    gap: '32px',
    height: 'fit-content',
    maxHeight: '114px',
    alignItems: 'start',
    '& > *:nth-child(1)': {
      height: '20px',
      width: '280px',
      flexShrink: 0,
      [theme.breakpoints.down('md')]: {
        width: '200px',
      },
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
    '& > *:nth-child(2)': {
      height: '265px',
      flex: '1 1 auto',
      minWidth: '200px',
    },
  },
  priceField: {
    display: 'flex',
    height: 'fit-content',
    maxHeight: '114px',
    gap: '32px',
    alignItems: 'start',
    '& > *:nth-child(1)': {
      height: '20px',
      width: '280px',
      flexShrink: 0,
      [theme.breakpoints.down('md')]: {
        width: '200px',
      },
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
    '& > *:nth-child(2)': {
      height: '265px',
      flex: '1 1 auto',
      minWidth: '200px',
    },
  },

  marketingTitleSection: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '169px',
    height: 'fit-content',
    width: '100%',
    backgroundColor: theme.palette.background.gray_50,
    border: '1px solid ' + theme.palette.border.secondary,
    borderRadius: '12px',
    padding: '24px 32px',
    gap: '20px',
    boxSizing: 'border-box',
    [theme.breakpoints.down('md')]: {
      padding: '20px 24px',
      minHeight: 'auto',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '16px 20px',
    },
  },

  marketingDescriptionSection: {
    display: 'flex',
    flexDirection: 'column',
    height: 'fit-content',
    width: '100%',
    backgroundColor: theme.palette.background.gray_50,
    border: '1px solid ' + theme.palette.border.secondary,
    borderRadius: '12px',
    padding: '24px 32px',
    gap: '20px',
    boxSizing: 'border-box',
    [theme.breakpoints.down('md')]: {
      padding: '20px 24px',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '16px 20px',
    },
  },
  marketingDescriptionField: {
    width: '100%',
    height: '100%',
    maxWidth: '512px',
    maxHeight: '160px',
    display: 'flex',
    alignItems: 'center',
  },
  marketingDescriptionFieldWrapper: {
    width: '100%',
    height: '100%',
    maxHeight: '180px',
    display: 'flex',
    alignItems: 'flex-start',
    gap: '32px',
    margin: '16px 0',
  },
  aiGenerateButtonContent: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    color: theme.palette.button.tertiary_fg,
  },
  headerSection: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    height: 'fit-content',
  },
  headerTitle: {
    fontFamily: 'Inter',
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '28px',
  },
  marketingUSP_Section: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '412px',
    height: 'fit-content',
    width: '100%',
    backgroundColor: theme.palette.background.gray_50,
    border: '1px solid ' + theme.palette.border.secondary,
    borderRadius: '12px',
    padding: '24px 32px',
    gap: '20px',
    boxSizing: 'border-box',
    [theme.breakpoints.down('md')]: {
      padding: '20px 24px',
      minHeight: 'auto',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '16px 20px',
    },
  },
}));
